import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.128 21.003h8.723c.727 0 1.327-.6 1.327-1.328V4.127c0-.728-.6-1.327-1.328-1.327H4.128c-.728 0-1.327.6-1.327 1.327v15.55c0 .726.6 1.326 1.327 1.326m-.19-16.876c0-.106.084-.19.19-.19h8.723c.106 0 .189.084.189.19v9.679c-1.328.053-2.534.515-3.382.94C8.36 14.239 7.1 13.8 5.903 13.8c-.645 0-1.305.091-1.965.281z",
      style: {"fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".7",
      d: "M8.677 9.627c.728 0 1.328-.6 1.328-1.328 0-.629-.44-1.152-1.024-1.289a1.68 1.68 0 0 0-1.441-.796c-.6 0-1.138.304-1.442.796A1.326 1.326 0 0 0 5.074 8.3c0 .727.6 1.327 1.328 1.327zM19.842 2.8h-1.66c-.64 0-1.16.595-1.16 1.327v15.55c0 .73.52 1.326 1.161 1.326h1.66c.64 0 1.16-.595 1.16-1.328V4.127c0-.732-.52-1.327-1.161-1.327",
      style: {"fill-opacity":".7"}
    }, null, -1)
  ])))
}
export default { render: render }